import { jsxs, jsx } from 'react/jsx-runtime';
import { useApi } from '@backstage/core-plugin-api';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect } from 'react';
import { apiDocsConfigRef } from '../../config.esm.js';
import { PlainApiDefinitionWidget } from '../PlainApiDefinitionWidget/PlainApiDefinitionWidget.esm.js';
import { useTranslationRef } from '@backstage/frontend-plugin-api';
import { apiDocsTranslationRef } from '../../translation.esm.js';

const useStyles = makeStyles((theme) => ({
  fullHeightDialog: {
    height: "calc(100% - 64px)"
  },
  root: {
    display: "flex",
    flexGrow: 1,
    width: "100%",
    height: "100%"
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    flexShrink: 0
  },
  tabContents: {
    flexGrow: 1,
    overflowX: "auto"
  },
  title: {
    color: theme.palette.text.primary,
    wordBreak: "break-word",
    fontSize: theme.typography.h3.fontSize,
    marginBottom: 0
  },
  type: {
    textTransform: "uppercase",
    fontSize: 11,
    opacity: 0.8,
    marginBottom: theme.spacing(1),
    color: theme.palette.text.primary
  }
}));
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  const classes = useStyles();
  return /* @__PURE__ */ jsx(
    "div",
    {
      role: "tabpanel",
      hidden: value !== index,
      id: `vertical-tabpanel-${index}`,
      "aria-labelledby": `vertical-tab-${index}`,
      className: classes.tabContents,
      ...other,
      children: value === index && /* @__PURE__ */ jsx(Box, { pl: 3, pr: 3, children })
    }
  );
}
function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`
  };
}
function ApiDefinitionDialog(props) {
  const { open, entity, onClose } = props;
  const [activeTab, setActiveTab] = useState(0);
  const classes = useStyles();
  const { t } = useTranslationRef(apiDocsTranslationRef);
  useEffect(() => {
    setActiveTab(0);
  }, [open]);
  const config = useApi(apiDocsConfigRef);
  const definitionWidget = config.getApiDefinitionWidget(entity);
  let tabIndex = 0;
  let tabPanelIndex = 0;
  return /* @__PURE__ */ jsxs(
    Dialog,
    {
      fullWidth: true,
      maxWidth: "xl",
      open,
      onClose,
      "aria-labelledby": "api-definition-dialog-title",
      PaperProps: { className: classes.fullHeightDialog },
      children: [
        /* @__PURE__ */ jsxs(DialogTitle, { id: "api-definition-dialog-title", disableTypography: true, children: [
          /* @__PURE__ */ jsxs(Typography, { className: classes.type, children: [
            "API - ",
            definitionWidget?.title ?? "Raw"
          ] }),
          /* @__PURE__ */ jsx(Typography, { className: classes.title, variant: "h1", children: entity.metadata.title ?? entity.metadata.name })
        ] }),
        /* @__PURE__ */ jsxs(DialogContent, { dividers: true, className: classes.root, children: [
          /* @__PURE__ */ jsxs(
            Tabs,
            {
              orientation: "vertical",
              variant: "scrollable",
              value: activeTab,
              onChange: (_, newValue) => setActiveTab(newValue),
              "aria-label": t("apiDefinitionDialog.tabsAriaLabel"),
              className: classes.tabs,
              children: [
                definitionWidget ? /* @__PURE__ */ jsx(Tab, { label: definitionWidget.title, ...a11yProps(tabIndex++) }) : null,
                /* @__PURE__ */ jsx(Tab, { label: "Raw", ...a11yProps(tabIndex++) })
              ]
            }
          ),
          definitionWidget ? /* @__PURE__ */ jsx(TabPanel, { value: activeTab, index: tabPanelIndex++, children: definitionWidget.component(entity.spec.definition) }) : null,
          /* @__PURE__ */ jsx(TabPanel, { value: activeTab, index: tabPanelIndex++, children: /* @__PURE__ */ jsx(
            PlainApiDefinitionWidget,
            {
              definition: entity.spec.definition,
              language: definitionWidget?.rawLanguage ?? entity.spec.type
            }
          ) })
        ] }),
        /* @__PURE__ */ jsx(DialogActions, { children: /* @__PURE__ */ jsx(Button, { onClick: onClose, color: "primary", children: t("apiDefinitionDialog.closeButtonTitle") }) })
      ]
    }
  );
}

export { ApiDefinitionDialog };
//# sourceMappingURL=ApiDefinitionDialog.esm.js.map
